Vue.component('familyInformation', {
    template: `
        <div id="familyInformation">

            <header>

                <img src="img/patbase_white.gif" alt="Patbase Logo" />

            </header>

            <div class="exports">
                <span @click="showExportModal" v-if="!isExporting">
                    <i class="fas fa-file-export"></i> {{ $language.export }}
                </span>
            </div>

            <div class="familyData bordered">

                <h3>{{ $language.famInfo }}</h3>

                <b>{{ $language.famNumber }}</b>: {{ fn }} <br />

                <template v-if="familyData.familycreatedweek">
                    <b>{{ $language.familyCreated || 'Family creation week' }}</b>: {{ paddy(familyData.familycreatedweek, 4) }} <a href="#" data-toggle="tooltip" class="dateTooltip" :title="getDateOfWeek(familyData.familycreatedweek, false) + ' - ' + getDateOfWeek(familyData.familycreatedweek, true)" ref="dateTooltip"><i class="fas fa-info-circle"></i></a><br />
                </template>
                <template v-if="firstUpdateWeek">
                    <b>{{ $language.fUpdWeek }}</b>: {{ paddy(firstUpdateWeek, 4) }} <a href="#" data-toggle="tooltip" class="dateTooltip" :title="getDateOfWeek(firstUpdateWeek, false) + ' - ' + getDateOfWeek(firstUpdateWeek, true)" ref="dateTooltip"><i class="fas fa-info-circle"></i></a> <br />
                </template>
                <template v-if="familyData.updateweek">
                    <b>{{ $language.lUpWeek }}</b>: {{ paddy(lastUpdateWeek, 4) }} <a href="#" data-toggle="tooltip" class="dateTooltip" :title="getDateOfWeek(lastUpdateWeek, false) + ' - ' + getDateOfWeek(lastUpdateWeek, true)" ref="dateTooltip"><i class="fas fa-info-circle"></i></a>
                </template>

            </div>

            <div class="members bordered">

                <div class="row membersHead">
                    <div class="col" @click="changeSort('pn')">{{ $language.pubNo }} <i :class="{'fa-sort': isNotSort('pn'), 'fa-sort-up': isSortUp('pn'), 'fa-sort-down': isSortDown('pn')}" class="fas"></i></div>
                    <div class="col" @click="changeSort('pd')">{{ $language.pubDate }} <i :class="{'fa-sort': isNotSort('pd'), 'fa-sort-up': isSortUp('pd'), 'fa-sort-down': isSortDown('pd')}" class="fas"></i></div>
                    <div class="col" @click="changeSort('an')">{{ $language.anNo }} <i :class="{'fa-sort': isNotSort('an'), 'fa-sort-up': isSortUp('an'), 'fa-sort-down': isSortDown('an')}" class="fas"></i></div>
                    <div class="col" @click="changeSort('ad')">{{ $language.anDate }} <i :class="{'fa-sort': isNotSort('ad'), 'fa-sort-up': isSortUp('ad'), 'fa-sort-down': isSortDown('ad')}" class="fas"></i></div>
                    <div class="col" @click="changeSort('uw')">{{ $language.uw }} <i :class="{'fa-sort': isNotSort('uw'), 'fa-sort-up': isSortUp('uw'), 'fa-sort-down': isSortDown('uw')}" class="fas"></i></div>
                </div>

                <div class="row membersRow" v-for="(member, index) in members" :style="{order: order.findIndex(function(el) {return el == index})}">
                    <div class="col">
                        {{ member.c_publicationnumber + ' ' + member.c_kindcode }}
                    </div>

                    <div class="col">
                        {{ member.c_publicationdate }}
                    </div>

                    <div class="col">
                        {{ member.c_applicationnumber }}
                    </div>

                    <div class="col">
                        {{ member.c_applicationdate }}
                    </div>

                    <div class="col">
                        {{ (member.c_updateweek)?paddy(member.c_updateweek, 4):'' }}
                    </div>
                </div>

            </div>

            <div class="infoMessage bordered">
                {{ $language.famExAllows }}<br />

                <b>Family Information</b> - {{ $language.famInfoExpl }}<br />

                <b>{{ $language.pubList }}</b> - {{ $language.pubListExpl }}<br />

                <b>Priority Map</b> - {{ $language.prioMapExpl }}<br />

                <b>Legal Status - Table</b> - {{ $language.legTabExpl }}<br />

                <b>Legal Status - Timeline</b> - {{ $language.legTimExpl }}<br />

                <b>Reassignments</b> - {{ $language.reasExpl }}<br />
            </div>

            <div id="exportModal" class="modal fade exportModal" tabindex="-1" role="dialog" ref="exportModal">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            {{ $language.exportFam.replace('[FAMNUM]', fn) }}
                        </div>
                        <div class="modal-body">

                            <p>
                                {{ $language.include }}:
                            </p>

                            <div class="membersCheck">
                                <label v-for="(member, index) in members">
                                    {{ member.c_publicationnumber + member.c_kindcode }}
                                    <input type="checkbox" :value="index" v-model="toExport"/>
                                </label>
                            </div>

                            <button type="button" class="btn" @click="exportFamily">Export</button>

                        </div>
                    </div>
                </div>
            </div>

            <div id="exportToast" :class="{showToast: isExporting}" class="show toast">
                <div class="toast-header">
                    <strong class="mr-auto">{{ $language.background }}</strong>
                </div>
                <div class="toast-body">
                    {{ $language.download }}
                </div>
            </div>

            <exportFamily v-show="false" :members="membersToExport"></exportFamily>

        </div>
    `,
    data: function() {
        return {
            order: [],
            sort: ['', 'desc'],
            toExport: []
        };
    },

    mounted() {

        EventBus.$on('FETCHED_MEMBERS', () => {
            for (var i = 0; i < this.members.length; i++) {
                this.order.push(i);
                this.toExport.push(i);
            }
        });

    },

    computed: {

        fn() {
            return this.$store.getters.fn;
        },

        familyData() {
            return this.$store.getters.familyData;
        },

        members() {
            return this.$store.getters.membersData;
        },

        isExporting() {
            return this.$store.getters.isExporting;
        },

        updateDate() {

            if (this.members.length != 0) {
                let lastDate = this.members[0].c_publicationdate;

                for (var member in this.members) {
                    if (this.members.hasOwnProperty(member)) {
                        if (lastDate < this.members[member].c_publicationdate) {
                            lastDate = this.members[member].c_publicationdate
                        }
                    }
                }

                return (lastDate) ? lastDate : null;

            } else {
                return null;
            }
        },

        membersToExport() {

            let members = this.members.filter((member, index) => {

                return this.toExport.indexOf(index) != -1;

            });

            return members;

        },

        firstUpdateWeek() {

            let updateWeek = null;

            this.members.forEach(member => {
                if (updateWeek == null || updateWeek > member.c_updateweek) {
                    updateWeek = member.c_updateweek;
                }
            });

            return updateWeek;

        },

        lastUpdateWeek() {
            let updateWeek = null;

            this.members.forEach(member => {
                if (updateWeek == null || updateWeek < member.c_updateweek) {
                    updateWeek = member.c_updateweek;
                }
            });

            return updateWeek;
        }
    },

    methods: {


        dateToReadable(date) {
            if (date) {

                let readable = helper.dates.toReadable(date, 'yyyymmdd', false);

                if (readable) {
                    return readable;
                } else {
                    return date;
                }
            }
        },

        changeSort(col) {

            if (this.sort[0] == col) {
                (this.sort[1] == 'desc') ? this.sort[1] = 'asc': this.sort[1] = 'desc';
            } else {
                this.sort[0] = col;
                this.sort[1] = 'desc';
            }

            let colMatch = {
                pn: 'c_publicationnumber',
                pd: 'c_publicationdate',
                an: 'c_applicationnumber',
                ad: 'c_applicationdate',
                uw: 'c_updateweek'
            };

            this.order.sort((a, b) => {

                let valA = this.members[a][colMatch[col]];
                let valB = this.members[b][colMatch[col]];

                if (this.sort[1] == 'desc') {
                    if (valA < valB) {
                        return -1;
                    }
                    if (valA > valB) {
                        return 1;
                    }
                    return 0;
                } else {
                    if (valA > valB) {
                        return -1;
                    }
                    if (valA < valB) {
                        return 1;
                    }
                    return 0;
                }

            });

        },

        isNotSort(col) {
            if (this.sort[0] != col) {
                return true;
            } else {
                return false;
            }
        },

        isSortUp(col) {
            if (this.sort[0] == col && this.sort[1] == 'desc') {
                return true;
            } else {
                return false;
            }
        },

        isSortDown(col) {
            if (this.sort[0] == col && this.sort[1] == 'asc') {
                return true;
            } else {
                return false;
            }
        },

        showExportModal() {
            $(this.$refs.exportModal).modal('show');
        },

        exportFamily() {
            EventBus.$emit('EXPORT_FAMILY');
            $(this.$refs.exportModal).modal('hide');
        },

        //function add leading zeros to update weeks
        paddy(num, padlen, padchar) {
            var pad_char = typeof padchar !== 'undefined' ? padchar : '0';
            var pad = new Array(1 + padlen).join(pad_char);
            return (pad + num).slice(-pad.length);
        },

        getDateOfWeek(pbWeek, endweek) {

            pbWeek = pbWeek.toString();

            pbWeek = this.paddy(pbWeek, 4);

            var y = '20' + pbWeek.substring(0, 2);
            var w = pbWeek.substring(2, 4);

            var simple;

            if (!endweek) {
                simple = new Date(y, 0, 1 + (w - 1) * 7);
            } else {
                simple = new Date(y, 0, (1 + (w - 1) * 7) + 7);
            }

            var dow = simple.getDay();
            var ISOweekStart = simple;

            if (dow <= 4) {
                ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
            } else {
                ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
            }

            return helper.dates.yyyymmdd(ISOweekStart);
        }

    }
});
